var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"top-time"},[_c('div',[_c('span',[_vm._v(_vm._s(_vm.transformSeconds3(_vm.onlineTime)))]),_c('span',[_vm._v(_vm._s(_vm.$t('lang.BaseModule.k042')))])]),_c('div',[_c('span',[_vm._v(_vm._s(_vm.transformSeconds5(_vm.callTime)))]),_c('span',[_vm._v(_vm._s(_vm.$t('lang.HostessTasks.k018')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }